import type { Statement } from '../../../types';

const ALL_WITH_TAGS = '*;';
const STARTS_WITH = '_*';

export function policyContainsPartial(policy: Statement[]) {
  const allResources = policy.flatMap((statement) => [
    ...(statement.resources || []),
    ...(statement.notResources || []),
  ]);
  return allResources.some((resource) => resourceContainsPartial(resource));
}

export function resourceContainsPartial(resource: string) {
  return resource.includes(ALL_WITH_TAGS) || resource.includes(STARTS_WITH);
}
